module.exports = __webpack_public_path__ + "static/media/fotogalereya13.62bf13f7.jpg";